module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items-list"
  }, [_c('ul', {
    staticClass: "items"
  }, [(!_vm.isEditPeriod) ? _c('li', {
    staticClass: "items__item"
  }, [(_vm.isKindergarten || _vm.isBruttoTid) ? _c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Periode")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_vm._v("\n          " + _vm._s(_vm.dateRangeFormatted) + "\n          "), _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": "Redigér periode"
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.onClickEditPeriod
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isEditPeriod) ? [_c('div', {
    staticClass: "calc-method"
  }, [_c('h3', [_vm._v("Vælg beregningsmetode")]), _vm._v(" "), _c('p', [_vm._v("Planlægges der for et helt skoleår/arbejdsår udgør arbejdstiden 1924 timer. Planlægges der for en del af et\n          skoleår/arbejdsår kan I selv vælge, hvilke af flg. metoder arbejdstiden skal beregnes ud fra.")]), _vm._v(" "), _c('ul', {
    staticClass: "d-radio-group"
  }, _vm._l((_vm.waysToCalculate), function(way) {
    return _c('li', {
      key: way.value,
      staticClass: "d-radio-group__radio",
      class: {
        'd-radio-group__radio--selected': _vm.theSelectedWayToCalculate === way.value
      },
      on: {
        "click": function($event) {
          return _vm.setTheSelectedWayToCalculate(way.value)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.theSelectedWayToCalculate),
        expression: "theSelectedWayToCalculate"
      }],
      attrs: {
        "type": "radio",
        "id": 'subject_subject_type_' + way.value
      },
      domProps: {
        "value": way.value,
        "checked": _vm._q(_vm.theSelectedWayToCalculate, way.value)
      },
      on: {
        "change": function($event) {
          _vm.theSelectedWayToCalculate = way.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "calc-method__label",
      attrs: {
        "for": 'subject_subject_type_' + way.value
      },
      domProps: {
        "innerHTML": _vm._s(way.title)
      }
    })])
  }), 0), _vm._v(" "), _c('p', [_vm._v("I nedenstående udregnes automatisk søgnehelligdage i perioden. Men du skal selv indtaste om den ansatte har\n          ferie, der ikke er brugt – altså både gammel ferie og ny optjent ferie")])]), _vm._v(" "), _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content",
    class: {
      'items__item__content--error': _vm.isErrorInStartDate
    }
  }, [_c('p', [_vm._v("Startdato")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.startDate,
      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month'
    },
    on: {
      "changed": _vm.setStartDate
    }
  })], 1)]), _vm._v(" "), (_vm.isErrorInStartDate) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content",
    class: {
      'items__item__content--error': _vm.isErrorInEndDate
    }
  }, [_c('p', [_vm._v("Slutdato")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('DateSelector', {
    attrs: {
      "isOnlyShowFirstAndLastDateEachMonth": _vm.theSelectedWayToCalculate === 'month',
      "date": _vm.endDate
    },
    on: {
      "changed": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isErrorInEndDate) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v("Skal være den første eller sidste dag i måneden")]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursPerWeek.hours),
      expression: "hoursPerWeek.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.hoursPerWeek.hours)
    },
    on: {
      "change": function($event) {
        return _vm.hoursPerWeekChanged($event.target.value, true)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hoursPerWeek, "hours", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.isBruttoTid) ? _c('li', {
    staticClass: "items__item"
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v("Beskæftigelsesgrad")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employmentPercentage.hours),
      expression: "employmentPercentage.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.employmentPercentage.hours)
    },
    on: {
      "change": function($event) {
        return _vm.employmentPercentageChanged($event.target.value)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.employmentPercentage, "hours", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "items__item",
    class: {
      'items__item--fixed': _vm.workingHours.isFixed
    }
  }, [_c('div', {
    staticClass: "items__item__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.workingHours.title))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("timer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workingHours.hours),
      expression: "workingHours.hours"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.workingHours.hours)
    },
    on: {
      "change": function($event) {
        return _vm.onEditWorkingHours($event.target.value)
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workingHours, "hours", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('ul', _vm._l((_vm.subtractedItems), function(subtractItem, idx) {
    return _c('li', {
      key: subtractItem.id,
      staticClass: "subtract-item items__item",
      class: {
        'subtract-item--fixed': subtractItem.isFixed
      }
    }, [_c('div', {
      staticClass: "subtract-item__title"
    }, [_c('div', {
      staticClass: "d-input-group__input__close icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.deleteItem(subtractItem)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })]), _vm._v("\n          " + _vm._s(subtractItem.title) + "\n          "), (subtractItem.id === 'holidays') ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away'
        }),
        expression: "{arrow: true, animateFill: false, animation: 'shift-away'}"
      }],
      staticClass: "icon__bg-circle holidays-settings-bttn",
      attrs: {
        "content": _vm.isOnlyPartOfSchoolYear ? 'Vis helligdage i perioden' : 'Redigér standard for søgnehelligdage'
      },
      on: {
        "click": _vm.onClickEditHolidaysStandard
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })]) : _vm._e(), _vm._v(" "), (subtractItem.id === 'local_agreement_adjustment') ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away'
        }),
        expression: "{arrow: true, animateFill: false, animation: 'shift-away'}"
      }],
      staticClass: "icon__bg-circle holidays-settings-bttn",
      attrs: {
        "content": "Redigér standard for tilpasning til lokalaftale"
      },
      on: {
        "click": _vm.onClickEditLocalAgreementStandard
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "input-group__input"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(subtractItem.unit ? subtractItem.unit : 'timer'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (subtractItem.hours),
        expression: "subtractItem.hours"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (subtractItem.hours)
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "change": function($event) {
          return _vm.setSubtractedItemValue(subtractItem, $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(subtractItem, "hours", $event.target.value)
        }
      }
    })])])
  }), 0)], 2), _vm._v(" "), _c('ul', {
    staticClass: "items",
    attrs: {
      "id": "items__list"
    }
  }, [(_vm.isAddNew) ? _c('li', {
    staticClass: "items__item items__item__add__new"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItemTitle),
      expression: "newItemTitle"
    }],
    ref: "add_new_input",
    attrs: {
      "type": "text",
      "placeholder": "Eks. Særlig reduktion"
    },
    domProps: {
      "value": (_vm.newItemTitle)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addOwn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItemTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "items__item__add__new__buttons"
  }, [_c('button', {
    staticClass: "bttn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    on: {
      "click": _vm.addOwn
    }
  }, [_vm._v("Gem")])])]) : _vm._e()]), _vm._v(" "), _c('DDropdown', {
    staticClass: "add-more__dropdown",
    attrs: {
      "isShowDots": false
    }
  }, [(!_vm.isAddNew) ? _c('p', {
    staticClass: "items__item__add",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("+ Tilføj reduktion")]) : _vm._e(), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('label', {
    staticClass: "d-label d-label__headline"
  }, [_vm._v("Vælg fra standard")]), _vm._v(" "), _vm._l((_vm.possibleStandardItems), function(possibleItem, idx) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.addFromStandard(possibleItem)
        }
      }
    }, [_vm._v(_vm._s(possibleItem.title) + "\n      ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "items__item__add",
    staticStyle: {
      "border-top": "1px solid #ddd",
      "margin-top": "0.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.setIsAddNew(true)
      }
    }
  }, [_vm._v("+\n        Opret egen\n      ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item__total"
  }, [_c('p', [_vm._v("Arbejdstid")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.nettoTime) + " timer")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5061dab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursNormList.vue
// module id = 1915
// module chunks = 1